export const isGuestUser = () => {
    return localStorage.getItem("profileType") === "GUEST_USER";
};